export default {
  path: '/wecode/booking/:aliasName',
  auth: false,
  preload: false,
  isStatic: true,
  key: 'booking',
  component: () => import('./index')
};
